module.exports = __webpack_public_path__ + "static/media/3DPPA15.81a212fb.jpg";